export default __webpack_public_path__ + "static/media/long_left_arrow_white.c558d949.svg";